import type { SVGProps } from 'react';

/**
 * Icon set that mirrors the Q Design Foundation Figma icon collection.
 * All icons use currentColor so they pick up the project's color tokens
 * via the consuming element's `color` property.
 */

type IconProps = SVGProps<SVGSVGElement>;

const BASE_PROPS = {
  width: 16,
  height: 16,
  viewBox: '0 0 24 24',
  fill: 'currentColor',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true,
} as const;

export const IconPlus = (props: IconProps) => (
  <svg {...BASE_PROPS} {...props}>
    <path d="M11 13H5a1 1 0 0 1 0-2h6V5a1 1 0 1 1 2 0v6h6a1 1 0 0 1 0 2h-6v6a1 1 0 1 1-2 0v-6z" />
  </svg>
);

export const IconClose = (props: IconProps) => (
  <svg {...BASE_PROPS} {...props}>
    <path d="M12 13.41 6.71 18.7a1 1 0 0 1-1.41-1.41L10.59 12 5.3 6.71A1 1 0 0 1 6.71 5.3L12 10.59l5.29-5.29a1 1 0 1 1 1.41 1.41L13.41 12l5.29 5.29a1 1 0 0 1-1.41 1.41L12 13.41z" />
  </svg>
);

export const IconCheck = (props: IconProps) => (
  <svg {...BASE_PROPS} {...props}>
    <path d="M9.55 17.05 4.85 12.35a1 1 0 0 1 1.41-1.41l3.29 3.29 7.19-7.19a1 1 0 1 1 1.41 1.41l-7.9 7.9a1 1 0 0 1-1.41 0z" />
  </svg>
);

export const IconChevronDown = (props: IconProps) => (
  <svg {...BASE_PROPS} {...props}>
    <path d="M12 14.96a1 1 0 0 1-.71-.29l-4.59-4.59a1 1 0 0 1 1.41-1.41L12 12.55l3.89-3.88a1 1 0 1 1 1.41 1.41l-4.59 4.59a1 1 0 0 1-.71.29z" />
  </svg>
);

export const IconDragIndicator = (props: IconProps) => (
  <svg {...BASE_PROPS} {...props}>
    <path d="M9 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm6 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zM9 10.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm6 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zM9 17a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm6 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z" />
  </svg>
);

export const IconClock = (props: IconProps) => (
  <svg {...BASE_PROPS} {...props}>
    <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm.5-13a1 1 0 0 0-1 1v4.59l-2.3 2.3a1 1 0 1 0 1.42 1.41l2.59-2.59a1 1 0 0 0 .29-.71V8a1 1 0 0 0-1-1z" />
  </svg>
);

export const IconTrash = (props: IconProps) => (
  <svg {...BASE_PROPS} {...props}>
    <path d="M9 3a1 1 0 0 0-1 1v1H5a1 1 0 1 0 0 2h1v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7h1a1 1 0 1 0 0-2h-3V4a1 1 0 0 0-1-1H9zm1 2h4v0H10v0zM8 7h8v12H8V7zm2 2a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0v-6a1 1 0 0 0-1-1zm4 0a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0v-6a1 1 0 0 0-1-1z" />
  </svg>
);

export const IconCalendar = (props: IconProps) => (
  <svg {...BASE_PROPS} {...props}>
    <path d="M7 2a1 1 0 0 1 1 1v1h8V3a1 1 0 1 1 2 0v1h1a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1V3a1 1 0 0 1 1-1zM5 9v10h14V9H5zm0-3v1h14V6H5z" />
  </svg>
);
